export function checkAdmin(permissions) {
  if (!permissions || !Array.isArray(permissions)) return false;

  return permissions.includes('ADMIN');
}
